import { lazy } from "react";

const InviterComptable = lazy(() => import("./InviterComptable"));

const accountantRoutes = [
  {
    path: "/inviter-comptable",
    element: <InviterComptable />,
  },
  {
    path: "/inviter-mon-comptable",
    element: <InviterComptable />,
  },
];

export default accountantRoutes;
